module.exports = __webpack_public_path__ + "static/banner_audiobook-fd9088c74f2397c5daa4522f0245ed4f.jpeg";